import React from "react";
import styled, { keyframes } from "styled-components";
import GridImg from "images/png/rated-tube-grid.png";
import PlatformImg from "images/png/rated-tube-img.png";
import Diamonds from "images/png/rated-tube-diamonds.png";
import RTBanner from "images/png/rated-tube-banner.png";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import PrimaryButton from "components/buttons/primary-button";
import FAQs from "../FAQs";

const Default = () => {
  return (
    <Container>
      <Grid alt="grid" src={GridImg} />
      <Header>
        <Typography color={Colors.white100} size="4xl" weight="bold" mr="0.4">
          Rated
        </Typography>
        <Typography color={Colors.yellow500} size="4xl" weight="bold">
          Tube
        </Typography>
      </Header>
      <HeroSection>
        <HeroText>
          <Typography
            lh="7.2"
            weight="semibold"
            size="6rem"
            m_size="4xl"
            m_lh="2.4"
          >
            Distribute Your Music Videos Globally.
          </Typography>
          <HeroBodyText>
            <Typography>
              <span> Rated-Tube</span> is a powerful feature within Rated Afrika
              Distro that allows artists to effortlessly distribute their music
              videos to major platforms like <span>Apple Music, Vevo </span>and
              <span>Tidal</span>.
            </Typography>
          </HeroBodyText>
          <GetStartedArea>
            <GetStartedText>
              <Typography weight="semibold" size="xl">
                Upload Unlimited Music Videos for only $10/mo
              </Typography>
              <div style={{ display: "flex", alignItems: "end" }}>
                <Typography
                  color={Colors.yellow500}
                  size="4rem"
                  weight="bold"
                  mr="0.6"
                >
                  $100
                </Typography>
                <Typography size="lg" lh="4">
                  billed annually
                </Typography>
              </div>
            </GetStartedText>
            <GetStartedImage src={Diamonds} alt="diamonds" />
            <GetStartedButton>
              <PrimaryButton
                inset
                sparkle
                text="Get Started"
                iconPosition="right"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M3.33301 10.5H16.6663M16.6663 10.5L11.6663 5.5M16.6663 10.5L11.6663 15.5"
                      stroke="#131313"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
              />
            </GetStartedButton>
          </GetStartedArea>
        </HeroText>
        <HeroImages>
          <PlatformImages src={PlatformImg} alt="platforms" />
        </HeroImages>
      </HeroSection>
      <Banner>
        <PhotoBanner>
          <BannerImage src={RTBanner} alt="banner" />
        </PhotoBanner>
      </Banner>
      <FAQs />
    </Container>
  );
};

export default Default;

const Container = styled.div`
  width: 100%;
  padding-top: 3.2rem;
  min-height: 100vh;
  max-height: 100%;
  position: relative;
`;

const Grid = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;

  @media only screen and (max-width: 769px) {
    width: 150rem;
    height: 100rem;
  }
`;

const Header = styled.div`
  display: inline-flex;
`;

const HeroSection = styled.div`
  margin-top: 3.2rem;
  display: flex;
  position: relative;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
  }
`;

const HeroText = styled.div`
  width: 44%;
  z-index: 2;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
const HeroBodyText = styled.div`
  display: inline-flex;
  color: #909090;
  margin-top: 1.5rem;

  p {
    font-size: 2rem;

    span {
      color: white;
      font-weight: 500;
    }

    @media only screen and (max-width: 769px) {
      font-size: 1.4rem;
    }
  }
`;

const HeroImages = styled.div`
  position: absolute;
  width: 65%;
  top: -50%;
  right: -6%;
  @media only screen and (max-width: 769px) {
    position: relative;
    width: 100%;
    top: 0;
    right: 0;
  }
`;

const PlatformImages = styled.img`
  object-fit: cover;
  width: 100%;
`;

const GetStartedArea = styled.div`
  margin-top: 3.4rem;
  padding: 1.4rem 2.4rem;
  width: 100%;
  border-radius: 1.1rem;
  border: 1px solid #4e4e4e;
  background: linear-gradient(106deg, #131313 1.36%, #5b5b5b 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  position: relative;
  @media only screen and (max-width: 769px) {
    padding: 1.4rem 1.2rem;
    flex-direction: column;
    align-items: start;
  }
`;

const GetStartedText = styled.div`
  width: 55%;
`;

const GetStartedButton = styled.div`
  width: 30%;
  height: 100%;
  position: relative;
  @media only screen and (max-width: 769px) {
    width: fit-content;
    margin-top: 1.2rem;
  }
`;

const GetStartedImage = styled.img`
  position: absolute;
  width: 17.1rem;
  object-fit: contain;
  top: 0;
  right: 0;
  @media only screen and (max-width: 769px) {
    top: 2rem;
  }
`;

const bannermove = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-50%, 0);
  }
`;

export const Banner = styled.div`
  height: 8rem;
  position: relative;
  overflow: hidden;
  margin-top: 20.4rem;
  @media only screen and (max-width: 769px) {
    height: 3.2rem;
    margin-top: 2rem;
  }
`;

export const PhotoBanner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  white-space: nowrap;
  animation: ${bannermove} 30s linear infinite;
`;

export const BannerImage = styled.img`
  margin: 0 0.5em;
  @media only screen and (max-width: 769px) {
    height: 3.2rem;
  }
`;
